import useAccommodationDefaultValue from "../../../../../hooks/common/searchers/defaultValues/useAccommodationDefaultValue.js";
import useClassesDefaultValue from "../../../../../hooks/common/searchers/defaultValues/useClassesDefaultValue.js";
import useDatesDefaultValue from "../../../../../hooks/common/searchers/defaultValues/useDatesDefaultValue.js";
import useDestinationDefaultValue from "../../../../../hooks/common/searchers/defaultValues/useDestinationDefaultValue.js";
import useDiscountsDefaultValue from "../../../../../hooks/common/searchers/defaultValues/useDiscountsDefaultValue.js";
import useOriginDefaultValue from "../../../../../hooks/common/searchers/defaultValues/useOriginDefaultValue.js";
const useSearcherFlightHotelDefaultValues = (props)=>{
    const { origin , destination , dates , accommodation , classes  } = props ?? {};
    const originDefaultValue = useOriginDefaultValue(origin);
    const destinationDefaultValue = useDestinationDefaultValue(destination);
    const datesDefaultValue = useDatesDefaultValue(dates);
    const accommodationDefaultValue = useAccommodationDefaultValue(accommodation);
    const classesDefaultValue = useClassesDefaultValue(classes);
    const discountsDefaultValue = useDiscountsDefaultValue();
    return {
        origin: originDefaultValue,
        destination: destinationDefaultValue,
        dates: datesDefaultValue,
        accommodation: accommodationDefaultValue,
        classes: classesDefaultValue,
        discounts: discountsDefaultValue
    };
};
export default useSearcherFlightHotelDefaultValues;

//# sourceMappingURL=useSearcherFlightHotelDefaultValues.js.map